import React, { ChangeEvent, useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { AppContext } from '../../../../common/context/';
import { InterruptionModel } from '../../../../models';
import { changeDate, getErrorsValidationsDates } from '../../../../utils/';
import { Modal } from '../BaseModal';
import { UpdateAndDeleteInterruptionProps } from './UpdateAndDeleteInterruption.Props';
import { InterruptionReferenceTableSelector } from '../../selectors/interruption/InterruptionReferenceTableSelector';

export const UpdateAndDeleteInterruptionModal = ({
    startDate,
    endDate,
    employee,
    interruption,
    isOpen,
    setModalOpen,
    saveUpdateAndDeleteInterruptions,
}: UpdateAndDeleteInterruptionProps) => {
    const {
        interruptionTypesList,
        lang,
        langResources,
        interruptionReferenceTypesList,
    } = useContext(AppContext);

    const [interruptionListCopy, setinterruptionListCopy] = useState<
        InterruptionModel[][]
    >([...interruption]);

    const [isEditing, setIsEditing] = useState(false);
    const [isAllDeleted, setIsAllDeleted] = useState(false);
    const [existingAnyError, setExistingAnyError] = useState(false);

    const handleChangeStartDate = (
        interruptionIndex: number,
        e: ChangeEvent<HTMLInputElement>,
        employeeId: number
    ) => {
        let interrup = changeDate(
            true,
            interruptionListCopy,
            interruptionIndex,
            e,
            employeeId
        );
        setinterruptionListCopy(interrup);
    };

    const handleChangeEndDate = (
        interruptionIndex: number,
        e: ChangeEvent<HTMLInputElement>,
        employeeId: number
    ) => {
        let interrup = changeDate(
            false,
            interruptionListCopy,
            interruptionIndex,
            e,
            employeeId
        );

        setinterruptionListCopy(interrup);
    };

    const handleChangePaid = (interruptionIndex: number, employeeId: number) => {
        let interrup = [...interruptionListCopy];

        let interrupCopy = [...interruptionListCopy][employeeId];

        let interruptionCopy = interrupCopy.map((i) => {
            let add = { ...i };

            if (add.id === interruptionIndex) {
                add!.isPaid = !add!.isPaid;
                return add;
            }
            return add;
        });

        interrup[employeeId] = [...interruptionCopy];

        setinterruptionListCopy([...interrup]);
    };

    const handleChangeAutomaticDiscount = (
        interruptionIndex: number,
        employeeId: number
    ) => {
        let interrup = [...interruptionListCopy];

        let interrupCopy = [...interruptionListCopy][employeeId];

        let interruptionCopy = interrupCopy.map((i) => {
            let add = { ...i };

            if (add.id === interruptionIndex) {
                add!.isAutomaticDiscount = !add!.isAutomaticDiscount;
                return add;
            }
            return add;
        });

        interrup[employeeId] = [...interruptionCopy];

        setinterruptionListCopy([...interrup]);
    };

    const handleDeleteInterruption = (
        interruptionIndex: number,
        employeeId: number
    ) => {
        let interrup = interruptionListCopy[employeeId][interruptionIndex];

        let interruptionCopy = { ...interrup };

        interruptionCopy.removeInterruption = true;

        let copyInterruptionList = [...interruptionListCopy];

        copyInterruptionList[employeeId][interruptionIndex] = interruptionCopy;

        setinterruptionListCopy([...copyInterruptionList]);
    };

    const handleDeleteAllInterruption = (isMultiplex: boolean) => {
        setIsAllDeleted(true);
        setExistingAnyError(false);

        if (isMultiplex) {
            let interruptionCopy = [...interruptionListCopy];
            let interruptionsListToDelete: InterruptionModel[][] = [];

            interruptionCopy.forEach((interr, index) => {
                let newInterruption = interr.map((i) => {
                    let interruption = { ...i };
                    interruption.removeInterruption = true;
                    return interruption;
                });

                interruptionsListToDelete.push(newInterruption);
            });

            setinterruptionListCopy([...interruptionsListToDelete]);
        } else {
            let interruptionsListToDelete: InterruptionModel[] = [];

            interruptionListCopy[0].map((interr) => {
                let interruptionCopy = { ...interr };
                interruptionCopy.removeInterruption = true;

                interruptionsListToDelete = [
                    ...interruptionsListToDelete,
                    interruptionCopy,
                ];
            });

            setinterruptionListCopy([[...interruptionsListToDelete]]);
        }
    };

    const handlerChangeObservations = (
        { target }: ChangeEvent<HTMLInputElement>,
        interruptionIndex: number,
        employeeId: number
    ) => {
        let interrup = [...interruptionListCopy];

        let interrupCopy = [...interruptionListCopy][employeeId];

        let interruptionCopy = interrupCopy.map((i) => {
            let add = { ...i };

            if (add.id === interruptionIndex) {
                add.observations = target.value;

                return add;
            }
            return add;
        });

        interrup[employeeId] = [...interruptionCopy];

        setinterruptionListCopy([...interrup]);
    };

    const confirmDeleteModal = () => {
        if (!existingAnyError) {
            saveUpdateAndDeleteInterruptions(interruptionListCopy, isAllDeleted);
        }
    };

    const handlerCloseParentModal = () => {
        setinterruptionListCopy(interruption);
        setModalOpen(false);
        setIsAllDeleted(false);
    };

    const handlerConfirmChanges = () => {
        let errors = getErrorsValidationsDates(interruptionListCopy);

        if (errors?.length > 0) {
            toast.error(langResources['msg.validation.endDate'], {
                isLoading: false,
                autoClose: 5000,
                position: toast.POSITION.BOTTOM_RIGHT,
                closeOnClick: true,
                closeButton: true,
            });
            setIsEditing(true);
            setExistingAnyError(true);
            return;
        } else {
            setIsEditing(false);
            setExistingAnyError(false);
        }
    };

    const getInterruptionReferenceName = (idReference: number) => {
        let reference = interruptionReferenceTypesList.filter(
            (irt) => irt.id === idReference
        )[0];

        return reference ? reference.name : '-- --';
    };

    const handleChangeReferenceID = (
        value: string,
        interruptionIndex: number,
        employeeId: number
    ) => {
        let referenceId = Number(value);

        let interrup = [...interruptionListCopy];

        let interrupCopy = [...interruptionListCopy][employeeId];

        let interruptionCopy = interrupCopy.map((i) => {
            let interr = { ...i };

            if (interr.id === interruptionIndex) {
                interr!.interruptionReferenceId =
                    referenceId === -1 ? undefined : referenceId;

                return interr;
            }
            return interr;
        });

        interrup[employeeId] = [...interruptionCopy];

        setinterruptionListCopy([...interrup]);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalTitle={langResources['update.delete.interruptions.modal']['title']}
            onClose={handlerCloseParentModal}
            onSubmit={confirmDeleteModal}
            widthCustom='1200px'
            disableSubmit={existingAnyError}
        >
            <div className='modal-body pb-1'>
                <div className='row mb-3'>
                    <div className='col-12'>
                        {interruptionListCopy?.length > 1 ? (
                            <div>
                                <h5 className='text-muted'>
                                    {
                                        langResources[
                                            'update.delete.interruptions.modal'
                                        ]['startDate']
                                    }
                                    : {startDate}
                                </h5>
                                <h5 className='text-muted'>
                                    {
                                        langResources[
                                            'update.delete.interruptions.modal'
                                        ]['endDate']
                                    }
                                    : {endDate}
                                </h5>
                            </div>
                        ) : (
                            <div>
                                <h5 className='fw-bolder'>
                                    {
                                        langResources[
                                            'update.delete.interruptions.modal'
                                        ]['employees.label']
                                    }
                                    :
                                </h5>
                                <h6>
                                    {interruptionListCopy[0][0].employeeFullName}
                                </h6>
                            </div>
                        )}
                    </div>
                </div>

                <div className='row align-items-center'>
                    <div className='col-8'>
                        <h5 className={`text-primary2`}>
                            {
                                langResources['update.delete.interruptions.modal'][
                                    'interruptions.list.label'
                                ]
                            }
                        </h5>
                    </div>

                    <div className='col-4 d-flex gap-2 align-items-center justify-content-end'>
                        {isEditing && (
                            <button
                                type='button'
                                title={
                                    langResources[
                                        'update.delete.interruptions.modal'
                                    ]['save.button']
                                }
                                className='btn btn-sm btn-success'
                                onClick={(e) => handlerConfirmChanges()}
                            >
                                <i className='mdi mdi-content-save'></i>
                                <span style={{ marginLeft: 5 }}>
                                    {
                                        langResources[
                                            'update.delete.interruptions.modal'
                                        ]['save.button']
                                    }
                                </span>
                            </button>
                        )}

                        {!isEditing && (
                            <button
                                title={
                                    langResources[
                                        'update.delete.interruptions.modal'
                                    ]['edit.button']
                                }
                                type='button'
                                className={`btn btn-sm btn-outline-primary
                                d-flex align-items-center`}
                                onClick={(e) => {
                                    setIsEditing(true);
                                    setExistingAnyError(true);
                                }}
                            >
                                <i className='mdi mdi-pencil'></i>
                                <span style={{ marginLeft: 5 }}>
                                    {
                                        langResources[
                                            'update.delete.interruptions.modal'
                                        ]['edit.button']
                                    }
                                </span>
                            </button>
                        )}

                        <button
                            type='button'
                            className='btn btn-danger btn-sm d-flex align-items-center'
                            onClick={(e) => {
                                if (employee && employee?.length > 1) {
                                    handleDeleteAllInterruption(true);
                                } else {
                                    handleDeleteAllInterruption(false);
                                }
                            }}
                        >
                            <i className='ri-delete-bin-2-line p-0'></i>
                            <span style={{ marginLeft: 5 }}>
                                {
                                    langResources[
                                        'update.delete.interruptions.modal'
                                    ]['delete.button']
                                }
                            </span>
                        </button>
                    </div>
                </div>
                <hr />

                <div className='w-100 d-flex mb-3'>
                    <div
                        className='row p-0 m-0'
                        style={{
                            maxHeight: '70vh',
                            overflowY: 'scroll',
                            width: '100%',
                        }}
                    >
                        <table className='table table-borderless w-100 text-dark p-0 mb-0'>
                            <thead
                                className=' text-black position-sticky p-0 m-0'
                                style={{ top: '0px', background: '#fff' }}
                            >
                                <tr
                                    className='text-center fs-6 '
                                    style={{
                                        height: 50,
                                        boxSizing: 'border-box',
                                        verticalAlign: 50,
                                    }}
                                >
                                    {interruptionListCopy?.length > 1 ? (
                                        <>
                                            <th
                                                scope='col'
                                                className=' py-2 fw-bold '
                                                style={{
                                                    width: 80,
                                                }}
                                            >
                                                {
                                                    langResources[
                                                        'update.delete.interruptions.modal'
                                                    ]['employees.label']
                                                }
                                            </th>

                                            <th
                                                scope='col'
                                                className=' py-2 fw-bold '
                                                style={{ background: '#fff' }}
                                            >
                                                {
                                                    langResources[
                                                        'update.delete.interruptions.modal'
                                                    ]['interruptions.day.label']
                                                }
                                                <div className='w-100 text-start mt-2'>
                                                    <span
                                                        className=' text-muted'
                                                        style={{
                                                            marginLeft:
                                                                lang == 'en-US'
                                                                    ? 40
                                                                    : 35,
                                                        }}
                                                    >
                                                        {
                                                            langResources[
                                                                'update.delete.interruptions.modal'
                                                            ]['date.label']
                                                        }
                                                    </span>

                                                    <span
                                                        className=' text-muted'
                                                        style={{
                                                            marginLeft:
                                                                lang == 'en-US'
                                                                    ? 80
                                                                    : 70,
                                                        }}
                                                    >
                                                        {
                                                            langResources[
                                                                'update.delete.interruptions.modal'
                                                            ][
                                                                'initial.date.end.date.label'
                                                            ]
                                                        }
                                                    </span>

                                                    <span
                                                        className=' text-muted '
                                                        style={{
                                                            marginLeft:
                                                                lang == 'en-US'
                                                                    ? 80
                                                                    : 70,
                                                        }}
                                                    >
                                                        {
                                                            langResources[
                                                                'update.delete.interruptions.modal'
                                                            ][
                                                                'interruption.name.label'
                                                            ]
                                                        }
                                                    </span>

                                                    <span
                                                        className='text-muted  d-inline-block'
                                                        style={{
                                                            marginLeft:
                                                                lang == 'en-US'
                                                                    ? 50
                                                                    : 30,
                                                        }}
                                                    >
                                                        {
                                                            langResources[
                                                                'update.delete.interruptions.modal'
                                                            ]['observation.label']
                                                        }
                                                    </span>

                                                    <span
                                                        className=' text-muted d-inline-block'
                                                        style={{
                                                            marginLeft:
                                                                lang == 'en-US'
                                                                    ? 15
                                                                    : 8,
                                                        }}
                                                    >
                                                        {
                                                            langResources[
                                                                'update.delete.interruptions.modal'
                                                            ]['is.paid.label']
                                                        }
                                                    </span>

                                                    <span
                                                        className=' text-muted d-inline-block'
                                                        style={{
                                                            marginLeft:
                                                                lang == 'en-US'
                                                                    ? 40
                                                                    : 9,
                                                        }}
                                                    >
                                                        {
                                                            langResources[
                                                                'update.delete.interruptions.modal'
                                                            ][
                                                                'is.automatic.discount.label'
                                                            ]
                                                        }
                                                    </span>

                                                    <span
                                                        className=' text-muted d-inline-block'
                                                        style={{
                                                            marginLeft:
                                                                lang == 'en-US'
                                                                    ? 30
                                                                    : 20,
                                                        }}
                                                    >
                                                        {
                                                            langResources[
                                                                'update.delete.interruptions.modal'
                                                            ][
                                                                'interruption.reference.label'
                                                            ]
                                                        }
                                                    </span>

                                                    <span></span>
                                                </div>
                                            </th>
                                        </>
                                    ) : (
                                        <>
                                            <th
                                                scope='col'
                                                className=' py-2 fw-bold '
                                                style={{
                                                    width: 100,
                                                }}
                                            >
                                                {
                                                    langResources[
                                                        'update.delete.interruptions.modal'
                                                    ]['date.label']
                                                }
                                            </th>
                                            <th
                                                scope='col'
                                                className=' py-2 fw-bold '
                                            >
                                                {
                                                    langResources[
                                                        'update.delete.interruptions.modal'
                                                    ]['initial.date.end.date.label']
                                                }
                                            </th>
                                            <th
                                                scope='col'
                                                className=' py-2 fw-bold '
                                            >
                                                {
                                                    langResources[
                                                        'update.delete.interruptions.modal'
                                                    ]['interruption.name.label']
                                                }
                                            </th>
                                            <th
                                                scope='col'
                                                className='py-2 fw-bold '
                                            >
                                                {
                                                    langResources[
                                                        'update.delete.interruptions.modal'
                                                    ]['observation.label']
                                                }
                                            </th>
                                            <th scope='col' className='fw-bold '>
                                                {
                                                    langResources[
                                                        'update.delete.interruptions.modal'
                                                    ]['is.paid.label']
                                                }
                                            </th>
                                            <th
                                                scope='col'
                                                className='py-2 fw-bold '
                                            >
                                                {
                                                    langResources[
                                                        'update.delete.interruptions.modal'
                                                    ]['is.automatic.discount.label']
                                                }
                                            </th>
                                            <th
                                                scope='col'
                                                className='py-2 fw-bold '
                                            >
                                                {
                                                    langResources[
                                                        'update.delete.interruptions.modal'
                                                    ]['interruption.reference.label']
                                                }
                                            </th>
                                            <th></th>
                                        </>
                                    )}
                                </tr>
                            </thead>

                            <tbody>
                                {interruptionListCopy?.length > 1
                                    ? interruptionListCopy.map((emp, id) => {
                                          return (
                                              <tr key={id}>
                                                  <th
                                                      style={{
                                                          width: 80,
                                                          paddingRight: 0,
                                                      }}
                                                  >
                                                      {
                                                          interruptionListCopy[id][0]
                                                              .employeeFullName
                                                      }
                                                  </th>

                                                  <th>
                                                      {interruptionListCopy[id].map(
                                                          (interr, interrID) => (
                                                              <tr
                                                                  key={interr.id}
                                                                  className={`align-items-center text-center ${
                                                                      interruptionListCopy[
                                                                          id
                                                                      ][interrID]
                                                                          .removeInterruption &&
                                                                      'd-none'
                                                                  }`}
                                                              >
                                                                  <th
                                                                      className='p-1'
                                                                      style={{
                                                                          width: 100,
                                                                      }}
                                                                  >
                                                                      {
                                                                          interr.startDate.split(
                                                                              'T'
                                                                          )[0]
                                                                      }
                                                                  </th>

                                                                  <th className='d-flex p-1'>
                                                                      <input
                                                                          type='time'
                                                                          name='startDate'
                                                                          defaultValue={
                                                                              interr.startDate.split(
                                                                                  'T'
                                                                              )[1]
                                                                          }
                                                                          onChange={(
                                                                              e
                                                                          ) =>
                                                                              handleChangeStartDate(
                                                                                  interr.id,
                                                                                  e,
                                                                                  id
                                                                              )
                                                                          }
                                                                          className='form-control  form-control-sm  text-dark'
                                                                          readOnly={
                                                                              !isEditing
                                                                          }
                                                                      />
                                                                      -
                                                                      <input
                                                                          type='time'
                                                                          name='endDate'
                                                                          defaultValue={
                                                                              interr.endDate.split(
                                                                                  'T'
                                                                              )[1]
                                                                          }
                                                                          onChange={(
                                                                              e
                                                                          ) =>
                                                                              handleChangeEndDate(
                                                                                  interr.id,
                                                                                  e,
                                                                                  id
                                                                              )
                                                                          }
                                                                          className='form-control  form-control-sm text-dark'
                                                                          readOnly={
                                                                              !isEditing
                                                                          }
                                                                      />
                                                                  </th>

                                                                  <th
                                                                      className='p-1'
                                                                      style={{
                                                                          width: 120,
                                                                          wordBreak:
                                                                              'break-word',
                                                                      }}
                                                                      title={
                                                                          interruptionTypesList.find(
                                                                              (
                                                                                  interrType
                                                                              ) =>
                                                                                  interrType.id ===
                                                                                  interr.interruptionTypeId
                                                                          )?.name
                                                                      }
                                                                  >
                                                                      {
                                                                          interruptionTypesList.find(
                                                                              (
                                                                                  interrType
                                                                              ) =>
                                                                                  interrType.id ===
                                                                                  interr.interruptionTypeId
                                                                          )?.name
                                                                      }
                                                                  </th>

                                                                  <th
                                                                      className='p-1'
                                                                      title={
                                                                          interr.observations
                                                                      }
                                                                      style={{
                                                                          width: 80,
                                                                          maxWidth: 80,
                                                                          maxHeight: 50,
                                                                          overflow:
                                                                              'hidden',
                                                                      }}
                                                                  >
                                                                      <input
                                                                          type='text'
                                                                          className='form-control  form-control-sm w-100 h-100 text-black'
                                                                          value={
                                                                              interr.observations
                                                                          }
                                                                          disabled={
                                                                              !isEditing
                                                                          }
                                                                          onChange={(
                                                                              e
                                                                          ) =>
                                                                              handlerChangeObservations(
                                                                                  e,
                                                                                  interr.id,
                                                                                  id
                                                                              )
                                                                          }
                                                                      />
                                                                  </th>

                                                                  <th
                                                                      className='p-1'
                                                                      style={{
                                                                          minWidth: 80,
                                                                      }}
                                                                  >
                                                                      <div className='form-check form-switch text-center checked-success'>
                                                                          <input
                                                                              role='switch'
                                                                              id='isPaidCheckBox'
                                                                              name='isPaid'
                                                                              type='checkbox'
                                                                              className='form-check-input '
                                                                              defaultChecked={
                                                                                  interr.isPaid
                                                                              }
                                                                              value={
                                                                                  interr.isPaid
                                                                                      ? 'true'
                                                                                      : 'false'
                                                                              }
                                                                              onChange={() =>
                                                                                  handleChangePaid(
                                                                                      interr.id,
                                                                                      id
                                                                                  )
                                                                              }
                                                                              disabled={
                                                                                  !isEditing
                                                                              }
                                                                          />
                                                                      </div>
                                                                  </th>

                                                                  <th
                                                                      className='p-1'
                                                                      style={{
                                                                          minWidth: 80,
                                                                      }}
                                                                  >
                                                                      <div className='form-check form-switch  text-center checked-success'>
                                                                          <input
                                                                              role='switch'
                                                                              id='isAutomaticDiscountCheckbox'
                                                                              name='isAutomaticDiscount'
                                                                              type='checkbox'
                                                                              className='form-check-input '
                                                                              value={
                                                                                  interr.isAutomaticDiscount
                                                                                      ? 'true'
                                                                                      : 'false'
                                                                              }
                                                                              defaultChecked={
                                                                                  interr.isAutomaticDiscount
                                                                              }
                                                                              onChange={(
                                                                                  e
                                                                              ) =>
                                                                                  handleChangeAutomaticDiscount(
                                                                                      interr.id,
                                                                                      id
                                                                                  )
                                                                              }
                                                                              disabled={
                                                                                  !isEditing
                                                                              }
                                                                          />
                                                                      </div>
                                                                  </th>

                                                                  <th className='p-1'>
                                                                      <InterruptionReferenceTableSelector
                                                                          name=''
                                                                          onChange={(
                                                                              e
                                                                          ) =>
                                                                              handleChangeReferenceID(
                                                                                  e,
                                                                                  interr.id,
                                                                                  id
                                                                              )
                                                                          }
                                                                          value={
                                                                              interr.interruptionReferenceId
                                                                          }
                                                                          disable
                                                                          label={getInterruptionReferenceName(
                                                                              interr.interruptionReferenceId ??
                                                                                  0
                                                                          )}
                                                                      />
                                                                  </th>

                                                                  <th className='p-1'>
                                                                      <button
                                                                          type='button'
                                                                          onClick={(
                                                                              e
                                                                          ) =>
                                                                              handleDeleteInterruption(
                                                                                  interrID,
                                                                                  id
                                                                              )
                                                                          }
                                                                          style={{
                                                                              padding:
                                                                                  '1px 2px',
                                                                          }}
                                                                          className='btn btn-danger btn-sm'
                                                                          disabled={
                                                                              !isEditing
                                                                          }
                                                                      >
                                                                          <i
                                                                              className='ri-delete-bin-2-line p-0'
                                                                              style={{
                                                                                  fontSize: 18,
                                                                              }}
                                                                          ></i>
                                                                      </button>
                                                                  </th>
                                                              </tr>
                                                          )
                                                      )}
                                                  </th>
                                              </tr>
                                          );
                                      })
                                    : interruptionListCopy[0].map(
                                          (interr, index) => (
                                              <tr
                                                  key={interr.id}
                                                  style={{
                                                      height: 2.5,
                                                      lineHeight: 2.5,
                                                  }}
                                                  className={`align-items-center text-center ${
                                                      interruptionListCopy[0][index]
                                                          .removeInterruption &&
                                                      'd-none'
                                                  }`}
                                              >
                                                  <th>
                                                      {
                                                          interr.startDate?.split(
                                                              'T'
                                                          )[0]
                                                      }
                                                  </th>

                                                  <th className='d-flex'>
                                                      <input
                                                          type='time'
                                                          name='startDate'
                                                          defaultValue={
                                                              interr.startDate.split(
                                                                  'T'
                                                              )[1]
                                                          }
                                                          onChange={(e) =>
                                                              handleChangeStartDate(
                                                                  interr.id,
                                                                  e,
                                                                  0
                                                              )
                                                          }
                                                          className='form-control  form-control-smform-control-sm text-dark'
                                                          readOnly={!isEditing}
                                                      />
                                                      -
                                                      <input
                                                          type='time'
                                                          name='endDate'
                                                          defaultValue={
                                                              interr.endDate.split(
                                                                  'T'
                                                              )[1]
                                                          }
                                                          onChange={(e) =>
                                                              handleChangeEndDate(
                                                                  interr.id,
                                                                  e,
                                                                  0
                                                              )
                                                          }
                                                          className='form-control  form-control-smform-control-sm text-dark'
                                                          readOnly={!isEditing}
                                                      />
                                                  </th>

                                                  <th
                                                      className=''
                                                      title={
                                                          interruptionTypesList.find(
                                                              (interrType) =>
                                                                  interrType.id ===
                                                                  interr.interruptionTypeId
                                                          )?.name
                                                      }
                                                  >
                                                      {
                                                          interruptionTypesList.find(
                                                              (interrType) =>
                                                                  interrType.id ===
                                                                  interr.interruptionTypeId
                                                          )?.name
                                                      }
                                                  </th>

                                                  <th
                                                      className=' '
                                                      title={interr.observations}
                                                  >
                                                      <input
                                                          type='text'
                                                          className='form-control  form-control-smw-100 h-100 text-black'
                                                          value={interr.observations}
                                                          disabled={!isEditing}
                                                          onChange={(e) =>
                                                              handlerChangeObservations(
                                                                  e,
                                                                  interr.id,
                                                                  0
                                                              )
                                                          }
                                                      />
                                                  </th>

                                                  <th className=''>
                                                      <div className='form-check form-switch  text-center checked-success'>
                                                          <input
                                                              role='switch'
                                                              id='isPaidCheckBox'
                                                              name='isPaid'
                                                              type='checkbox'
                                                              className='form-check-input '
                                                              defaultChecked={
                                                                  interr.isPaid
                                                              }
                                                              value={
                                                                  interr.isPaid
                                                                      ? 'true'
                                                                      : 'false'
                                                              }
                                                              onChange={() =>
                                                                  handleChangePaid(
                                                                      interr.id,
                                                                      0
                                                                  )
                                                              }
                                                              disabled={!isEditing}
                                                          />
                                                      </div>
                                                  </th>

                                                  <th className=''>
                                                      <div className='form-check form-switch  text-center checked-success'>
                                                          <input
                                                              role='switch'
                                                              id='isAutomaticDiscountCheckbox'
                                                              name='isAutomaticDiscount'
                                                              type='checkbox'
                                                              className='form-check-input '
                                                              value={
                                                                  interr.isAutomaticDiscount
                                                                      ? 'true'
                                                                      : 'false'
                                                              }
                                                              defaultChecked={
                                                                  interr.isAutomaticDiscount
                                                              }
                                                              onChange={(e) =>
                                                                  handleChangeAutomaticDiscount(
                                                                      interr.id,
                                                                      0
                                                                  )
                                                              }
                                                              disabled={!isEditing}
                                                          />
                                                      </div>
                                                  </th>

                                                  <th>
                                                      <InterruptionReferenceTableSelector
                                                          name=''
                                                          onChange={(e) =>
                                                              handleChangeReferenceID(
                                                                  e,
                                                                  interr.id,
                                                                  0
                                                              )
                                                          }
                                                          value={
                                                              interr.interruptionReferenceId
                                                          }
                                                          disable
                                                          label={getInterruptionReferenceName(
                                                              interr.interruptionReferenceId ??
                                                                  0
                                                          )}
                                                      />
                                                  </th>

                                                  <th className=''>
                                                      <button
                                                          type='button'
                                                          onClick={(e) =>
                                                              handleDeleteInterruption(
                                                                  index,
                                                                  0
                                                              )
                                                          }
                                                          style={{
                                                              padding: '1px 2px',
                                                          }}
                                                          className='btn btn-danger btn-sm'
                                                          disabled={!isEditing}
                                                      >
                                                          <i
                                                              className='ri-delete-bin-2-line p-0'
                                                              style={{
                                                                  fontSize: 18,
                                                              }}
                                                          ></i>
                                                      </button>
                                                  </th>
                                              </tr>
                                          )
                                      )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
